import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27359d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 5 }
const _hoisted_3 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ttn_timer = _resolveComponent("ttn-timer")!

  return (_ctx.column.key === 'actions' && _ctx.row.invoiceId && _ctx.row.statusId === 6)
    ? (_openBlock(), _createBlock(_component_button_dropdown, {
        key: 0,
        icon: "fas fa-ellipsis-h"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_new_button, {
            class: "NewButton--transparent InventoryTable__btn",
            onClick: _ctx.emitWaitList
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить в ЛО ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }))
    : (_ctx.isDirection)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.row.direction.fromCity.name) + " - " + _toDisplayString(_ctx.row.direction.whereCity.name), 1))
      : (_ctx.column.key === 'transportType' && _ctx.row.transportType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.transportType.name), 1)
          ], 64))
        : (_ctx.column.key === 'hasChangedDeliveryDateConfirmed' && _ctx.row.invoiceId)
          ? (_openBlock(), _createElementBlock("i", {
              key: 3,
              class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.hasChangedDeliveryDateConfirmed))
            }, null, 2))
          : (_ctx.column.key === 'invoiceNumber')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                class: "text-blue-500",
                to: `/invoice/${_ctx.row.invoiceId}`,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_ctx.column.key === 'company' && _ctx.row.company)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.row.company.shortName), 1))
              : (_ctx.isFromCity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.row.direction.fromCity.name), 1))
                : (_ctx.column.key === 'navigation' && _ctx.row.navigation)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createTextVNode(_toDisplayString(_ctx.row.navigation.name), 1)
                    ], 64))
                  : (_ctx.column.key === 'timer')
                    ? (_openBlock(), _createBlock(_component_ttn_timer, {
                        key: 8,
                        date: _ctx.row.deliveryDatePrediction,
                        "with-minus": ""
                      }, null, 8, ["date"]))
                    : (_ctx.column.key === 'timerDelivery' && _ctx.row.timeUntilOnTheWay)
                      ? (_openBlock(), _createBlock(_component_ttn_timer, {
                          key: 9,
                          date: _ctx.row.timeUntilOnTheWay,
                          "with-minus": ""
                        }, null, 8, ["date"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                          _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                        ], 64))
}